import { serializeTitle } from '@/utils/index.js'

export default [
  {
    // path: '/news',
    // name: 'News',
    // component: () => import(/* webpackChunkName: "general" */ '@/views/News.vue'),
    // meta: {
    //   title: serializeTitle('Nouveautés'),
    //   requiresAuth: true,
    //   requiresCustomer: true,
    // }, 
  // }, {
    path: '*', 
    redirect: '/collection/references/',
  }
]